module.exports = __webpack_public_path__ + "img/p12.96b941e9.png";